import HealthClaimDetail from './HealthClaimDetail'

export default HealthClaimDetail
